import { createFileRoute } from '@tanstack/react-router';
import { requireFeature } from '@portal/platform/guards';
import { OffersPage } from '@/features/vehicle-service-offers/offers-page';

/** The used-car service price list, in the type's sidebar section. Requires `pricing:read`. */
export const Route = createFileRoute('/_app/vehicle-service-offers/used-car')({
  staticData: { featureKey: 'vehicle-service-offers' },
  beforeLoad: ({ context, location }) =>
    requireFeature(context, location, {
      feature: 'vehicle-service-offers',
      permissions: ['pricing:read'],
    }),
  component: () => <OffersPage lockedType="USED_CAR" />,
});
